<template>
  <el-container>
    <el-header>
      <navmenu/>
    </el-header>
    <el-main>
      <div class="block">
        <el-carousel trigger="click" height="460px" indicator-position="none" arrow="never">
          <el-carousel-item v-for="item in imgList" :key="item.name">
            <div class="pic_item">
              <img :src="item.src" style="height:100%;width:100%;" alt="图片丢失了" />
              <h3>{{item.title}}</h3>
              <p>{{item.detail}}</p>
            </div>
          </el-carousel-item>
        </el-carousel>
      </div>
      <div class="solution">
        <div class="digital_1">
          <div class="share">
            <div style="height:45px;width:415px;margin:0 auto;"><h2>人力服务</h2></div>
            <span></span>
          </div>       
          <div class="view-tip">
            <p class="title">服务优势</p>
            <div class="detail">
              <span>全覆盖的行业信息解决方案</span>
              <p>提供金融、工业、制造业、互联网、高科技、电信、新零售、电商等覆盖全行业的解决方案</p>
              <span>全栈全生命周期人力资源服务</span>
              <p>提供开发、测试、敏捷、运维、定制化服务等解决方案，配备有雄厚的开发及测试人才储备能力</p>
              <span>丰富的金融领域业务专业知识</span>
              <p>拥有理财类产品业务、金融产品交易业务、银行类产品业务、保险类产品业务等领域丰富的开发测试经验</p>
            </div>
          </div>
          <div class="view-tip">
            <p class="title">过程管理</p>
            <div class="picImg"><img src="../../public/humanImg/service1.png" alt=""></div>
          </div>
        </div>  
      </div>    
    </el-main>
    <el-footer>
      <footerMenu/>
    </el-footer>
  </el-container>
</template>

<script>
import navmenu from '../components/navmenu.vue';
import footerMenu from '../components/footer.vue';

export default {
  components: { navmenu,footerMenu },

  data(){
    return{
      imgList:[
        {
          name: "banner1",
          title:'人力服务',
          detail:'Human services',
          src: require("../../public/humanImg/servebanner.png"),
        },
      ]
    }
  }
}
</script>
<style lang="scss" scoped>
.share{
  padding:60px 0 60px 0;
  span{
    height: 3px;
    width: 44px;
    display: inline-block;
    background-color: #C5C5C5;
  }
}

.block{
  position: relative;
  .pic_item {
    position: relative;
    height: 100%;
    h3{
      position: absolute;
      width: 1200px;
      left: 50%;
      transform: translateX(-50%);
      text-align: left;
      top: 132px;        
      font-size: 60px;
      font-family: PingFang SC;
      font-weight: 800;
      line-height: 100px;
      color: #FFFFFF;
      opacity: 1;
      animation:moveh3 3s infinite;
      // animation-iteration-count:1;
      @keyframes moveh3{
        from {left:60%;opacity: 0;}
        to {left:50%;opacity: 1;}
      }
      @-webkit-keyframes moveh3 /*Safari and Chrome*/{
        from {left:60%;opacity: 0;}
        to {left:50%;opacity: 1;}
      }
    }      
    p{
      position: absolute;
      width: 1200px;
      left: 50%;
      transform: translateX(-50%);
      text-align: left;
      top: 242px;        
      font-size: 20px;
      font-family: PingFang SC;
      font-weight: 400;
      line-height: 100px;
      color: #FFFFFF;
      opacity: 1;
      animation:movep 3s infinite;
      @keyframes movep{
        from {top: 282px;opacity: 0;}
        to {top: 242px;opacity: 1;}
      }
      @-webkit-keyframes movep /*Safari and Chrome*/{
        from {top: 282px;opacity: 0;}
        to {top: 242px;opacity: 1;}
    }
    }      
  }
  .pic_item:hover{
    cursor: pointer;
  }
}

  .view-tip{
    width: 1200px;   
    margin: 0 auto;
    margin-bottom: 90px;
    text-align: left;
    .title{
      height: 33px;
      text-align: left;
      font-size: 24px;
      font-weight: bold;
      margin: 0 0 10px;
      padding-left: 10px;
      border-left: solid 3px #1E8DD4;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: pre !important;
    }
    .detail{
      margin-top: 32px;
      text-align: left;
      font-size: 16px;
      line-height: 32px;
      color: #666;
      padding-left: 13px;
      p{
        margin-top:-3px
      }
      span{
        font-size: 18px;
        font-weight: bold;
        line-height: 20px;
        margin-bottom: 10px;
      }
      ul{
        list-style-type: none;
        margin-left: 5px;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        li{
          padding-bottom: 20px;
          // width: 326px;
        }
      }
    }
  }
.digital_1{
  height: 1238px;
  .picImg{
    margin-top: 32px;
    img{
      width: 1200px;
    }
  }
}

.solution{
  // height:1460px;
}
</style>


// WEBPACK FOOTER //
// src/views/humanServices.vue